var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemaOscuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.81 95.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.92,95.79c-13.56-.01-26.49-5.76-35.58-15.83C3.18,69.88-1.21,56.35.29,42.81,2.74,21.41,19.04,4.21,40.27.61c6.68-1.03,13.5-.75,20.08.82,5.34,1.37,8.55,6.81,7.18,12.15-.46,1.8-1.42,3.43-2.76,4.72-18.2,16.63-16.62,42.48,3.22,57.51,4.33,3.4,5.09,9.67,1.69,14.01-1.16,1.48-2.71,2.6-4.48,3.23-5.58,1.82-11.41,2.75-17.29,2.74Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemaOscuro);
export default __webpack_public_path__ + "static/media/temaOscuro.17b48a508cc0d7e165faa9bc666600ae.svg";
export { ForwardRef as ReactComponent };